import { Box, Divider, Flex } from "@chakra-ui/react";
import { formatDateValue } from "@equidefi/i18n";
import { offeringHidesSecurityLabel } from "@equidefi/shared";
import type { DTO } from "@equidefi/shared/types/dto";
import { Text } from "@equidefi/ui";
import type React from "react";

import { CurrencyFormatter, NumberFormatter } from "@/constants/format";

const DetailRow: React.FC<{ label: React.ReactNode; value: React.ReactNode }> = ({ label, value }) => (
  <Flex justify="space-between" align="center" py={2}>
    <Text fontSize={{ base: "sm", md: "md" }} m={0}>
      {label}
    </Text>
    <Text fontSize={{ base: "sm", md: "md" }} textAlign="right" m={0}>
      {value}
    </Text>
  </Flex>
);

interface InvestmentDetailsCardProps {
  investment: DTO.Investment;
  offering: DTO.Offering | null | undefined;
}

export const InvestmentDetailsCard: React.FC<InvestmentDetailsCardProps> = ({ investment, offering }) => {
  const hideSecurityLabel = offeringHidesSecurityLabel(offering);
  const completionDate = investment.status === "CLOSED" ? investment.modify_date : null;

  return (
    <Box bg="white" borderRadius={{ base: "10px", md: "12px" }} boxShadow="card" p={{ base: 4, md: 5 }}>
      <Text
        m="0"
        mb="1"
        color="gray.500"
        fontSize="xs"
        fontWeight="bold"
        letterSpacing="0.08em"
        textTransform="uppercase">
        Investment Details
      </Text>

      <DetailRow label="Amount Invested" value={CurrencyFormatter.format(Number(investment.amount ?? 0))} />
      {!hideSecurityLabel && (
        <>
          <DetailRow
            label={offering?.security_type_plural}
            value={
              <>
                {NumberFormatter.format(Number(investment.quantity ?? 0))}{" "}
                {offering?.security_type_plural?.toLowerCase()}
              </>
            }
          />
          <DetailRow
            label={`${offering?.security_type_label} Price`}
            value={CurrencyFormatter.format(Number(investment.price ?? 0))}
          />
        </>
      )}

      <Divider my="2" />

      <DetailRow label="Date Started" value={formatDateValue(investment.create_date) || "-"} />
      {completionDate && <DetailRow label="Date Completed" value={formatDateValue(completionDate) || "-"} />}
    </Box>
  );
};

export default InvestmentDetailsCard;
